/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BauHauptGewerbeSektor {
    Baumeister = 'Baumeister',
    PlanenderBaumeister = 'PlanenderBaumeister',
    BaugewerbeTreibender = 'BaugewerbeTreibender'
  }

    export const BauHauptGewerbeSektorTranslocoMap: Record<BauHauptGewerbeSektor, string> = {
    [BauHauptGewerbeSektor.Baumeister]: 'bauHauptGewerbeSektor.baumeister',
    [BauHauptGewerbeSektor.PlanenderBaumeister]: 'bauHauptGewerbeSektor.planenderBaumeister',
    [BauHauptGewerbeSektor.BaugewerbeTreibender]: 'bauHauptGewerbeSektor.baugewerbeTreibender',
    };

    export const BauHauptGewerbeSektorOptions = [
  { value: BauHauptGewerbeSektor.Baumeister, labelKey: 'bauHauptGewerbeSektor.baumeister' },
  { value: BauHauptGewerbeSektor.PlanenderBaumeister, labelKey: 'bauHauptGewerbeSektor.planenderBaumeister' },
  { value: BauHauptGewerbeSektor.BaugewerbeTreibender, labelKey: 'bauHauptGewerbeSektor.baugewerbeTreibender' },
    ];

